import { CurrentRatioValues, CurrentRatioResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateCurrentRatio(values: CurrentRatioValues, t?: ToolsTranslations['currentRatio']): CurrentRatioResult {
  const { currentAssets, inventory, workInProgress, currentLiabilities } = values;

  if (currentAssets < 0) return { ratio: null, percent: null, isValid: false, message: t?.invalid.currentAssets };
  if (inventory < 0) return { ratio: null, percent: null, isValid: false, message: t?.invalid.inventory };
  if (workInProgress < 0) return { ratio: null, percent: null, isValid: false, message: t?.invalid.workInProgress };
  if (currentLiabilities <= 0) return { ratio: null, percent: null, isValid: false, message: t?.invalid.currentLiabilities };

  const totalCurrentAssets = currentAssets + inventory + workInProgress;
  const ratio = totalCurrentAssets / currentLiabilities;
  const percent = Math.round(ratio * 100); // no decimals for percent
  const ratioRounded = Math.round(ratio * 100) / 100; // 2 decimals

  if (!isFinite(ratioRounded)) return { ratio: null, percent: null, isValid: false, message: t?.invalid.generic };

  return { ratio: ratioRounded, percent, isValid: true };
}


